// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 1000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Brady Lewis",
  title: "Hello, I'm Brady",
  heading: "Technology Executive & AI Transformation Leader driving enterprise innovation through strategic vision and proven execution.",
  subTitle: emoji(
    "I've built and led high-performing technical teams while architecting multi-million dollar technology solutions for Fortune 500 companies. As former Manager of Architects at Salesforce, I directed up to $15M+ in annual consulting services and spearheaded technical enablement initiatives that elevated entire organizations."
  ),
  subtitle_2: "Currently scaling AI-powered platforms as Technical Co-Founder of multiple ventures while perfecting digital transformation strategies. I translate emerging technology opportunities into sustainable competitive advantages, combining deep technical expertise with business acumen to deliver measurable ROI.",
  resumeLink:
    "https://otp.nyc3.cdn.digitaloceanspaces.com/Brady%20Lewis%20-%20AI%20Innovator%20Executive%20-%2005-24-2025.docx", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/bradyllewis",
  linkedin: "https://www.linkedin.com/in/bradyllewis/",
  gmail: "bradyllewis@gmail.com",
  twitter: "https://x.com/bradylewistech",
  //facebook: "https://www.facebook.com/saad.pasta7",
  medium: "https://medium.com/@bradyllewis",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "AI-POWERED SOLUTIONS ARCHITECT & TECHNICAL LEADER",
  skills: [
    emoji(
      "⚡ Executive Technology Strategy - Partner with C-suite leadership to define long-term technology roadmaps, evaluate emerging AI/ML trends, and align technical investments with business objectives for sustainable competitive advantage"
    ),
    emoji(
      "⚡ Digital Transformation Leadership - Guide enterprise-wide technology modernization initiatives, leading cross-functional teams through complex system migrations and organizational change management while ensuring minimal business disruption"
    ),
    emoji(
      "⚡ Full-Stack AI Application Development - Design and deploy end-to-end generative AI applications across web, iOS, and Android platforms using React, React-Native, NextJs, Node.js, and modern cloud infrastructure"
    ),
    emoji("⚡ Architect complex omni-channel marketing automation systems, data integrations, and personalized customer experiences for Fortune 500 companies"),
    emoji(
      "⚡ Scalable Infrastructure & API Design - Build robust, secure backend systems with MongoDB, AWS cloud services, and RESTful APIs that handle millions of users and transactions"
    ),
    emoji("⚡ AI Content Workflow Automation - Create intelligent business process automation tools that streamline content creation, marketing operations, and organizational productivity"),
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    /*{
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }*/
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Indiana University",
      logo: require("./assets/images/indianaUniversityLogo.jpg"),
      subHeader: "Bachelor of Science in Informatics",
      duration: "Minor in Computer Science",
      //desc: "Participated in the research of XXX and published 3 papers.",
      descBullets: [
        "A.A.S. in Computer Information Systems",
        "Java Programming Technical Certificate",
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Leadership/Strategy",
      progressPercentage: "90%"
    },
    {
      Stack: "Emerging Technologies",
      progressPercentage: "80%"
    },
    {
      Stack: "Marketing Technology",
      progressPercentage: "95%"
    },
    {
      Stack: "Frontend/Design",
      progressPercentage: "90%"
    },
    {
      Stack: "Backend/Infrastructure",
      progressPercentage: "90%"
    },
    {
      Stack: "AI/Machine Learning",
      progressPercentage: "85%"
    },
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Technical Co-Founder",
      company: "Flow Orchestra",
      companylogo: require("./assets/images/flowOrchestraLogo.png"),
      date: "Aug 2024 – Present",
      desc: "As Technical Co-Founder of Flow Orchestra, I spearheaded the development of an innovative AI-powered content workflow platform that transforms how businesses create and deploy content at scale.",
      descBullets: [
        "Architected and developed the entire platform from concept to launch, including custom-built AI workflow engines, agent systems, and scheduling functionality that enable true content automation",
        "Created advanced scheduling capabilities that enable fully autonomous content creation pipelines, dramatically reducing human intervention while maintaining content quality",
        "Built comprehensive systems for blog posts, e-books, social media content, and emails (just to name a few) that slash production time and resource requirements",
        "Developed Node.js backend server integrating with OpenAI, MongoDB, and n8n workflows to automate complex content generation tasks",
        "Designed and implemented custom n8n agents and workflows that orchestrate content creation processes, leveraging multi-layer AI quality processes to ensure professional results",
      ]
    },
    {
      role: "Technical Co-Founder",
      company: "GAIM.AI",
      companylogo: require("./assets/images/gaimLogo.png"),
      date: "Feb 2022 – Present",
      desc: "Co-Founded and built a pioneering consumer-facing AI platform available on web, iOS, and Android that makes advanced multimodal AI capabilities accessible to everyday users.",
      descBullets: [
        "Designed and built a comprehensive AI ecosystem featuring multimodal capabilities: role-trained chatbots, text-to-image generation, image-to-image transformation, computer vision, and interactive AI characters",
        "Single-handedly coded all three platform versions (web, iOS, Android), designing unified experiences while optimizing for platform-specific capabilities",
        "Built robust backend infrastructure supporting thousands of users while maintaining performance and reliability across diverse use cases",
        "Created intuitive interfaces that make complex AI technologies accessible to non-technical users while preserving advanced capabilities",
        "Onboarded several thousand users across platforms, maintaining high engagement through continuous feature development and performance optimization"
      ]
    },
    {
      role: "Sr. Manager, Principal Technical Architect",
      company: "Salesforce",
      companylogo: require("./assets/images/salesforceLogo.jpg"),
      date: "Jan 2015 – Feb 2022",
      desc: "Dual role as a senior people manager overseeing a remote team of platform and solutions archtects while leading high-visibility client engagements as a trusted advisor.",
      descBullets: [
        "Managed a team of program architects and technical architects within the Technical Services organization who are responsible for performing up to $15M of consulting services annually",
        "Drafted the interview questions guidelines for all Salesforce Marketing Cloud Technical Architect applicant interviews",
        "Built a custom Slack/Google Sheets application to create a fun contest out of time card compliance which raised compliance dramatically across the entire Technical Consulting Group",
        "Co-Led a six-month enablement/training initiative which saw 20+ campaign operations resources train to level up to the technical consulting group resulting in several successful promotions",
        "Developed deep relationships with client stakeholders at Fortune 500 companies, providing strategic guidance on digital transformation initiatives. My clients included: Office Depot, Ulta Beauty, FedEx, Bank of America, Belk, and more.",
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Notable Projects",
  subtitle: "EXPLORE A SELECTION OF PROJECTS THAT SHOWCASE MY EXPERTISE AND INNOVATION.",
  projects: [
    {
      image: require("./assets/images/markdown_town_logo.png"),
      projectName: "Markdown Town",
      projectDesc: "Quickly transform boring text into beautiful, shareable images and web pages with Markdown Town. Effortlessly create interactive stories, charts, quizzes, and more.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://markdowntown.app/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/flowOrchestraLogo.png"),
      projectName: "Flow Orchestra",
      projectDesc: "Flow Orchestra is the AI-powered content creation platform that helps you create high-quality, engaging content at scale. Whether you need blog posts, social media updates, or marketing materials, Flow Orchestra has you covered.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://floworchestra.com"
        }
      ]
    },
    {
      image: require("./assets/images/gaimLogoBlack.png"),
      projectName: "GAIM.AI",
      projectDesc: "GAIM.AI is the AI app that makes it easy to use AI for chat, image generation, image analysis, and more. Available on web, iOS, and Android, GAIM.AI is the perfect way to get started with AI.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://gaim.ai"
        }
      ]
    },
    {
      image: require("./assets/images/aheadofthegapLogo.png"),
      projectName: "Ahead of the Gap",
      projectDesc: "Curated and interactive digital resources equip you with essential AI skills quickly and effectively, transforming your professional journey. Gain the knowledge you need to thrive in a tech-driven world.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://aheadofthegap.com"
        }
      ]
    },
    {
      image: require("./assets/images/quickCheapWebsitesLogo.png"),
      projectName: "Quick Cheap Websites",
      projectDesc: "Listen, you need a website that doesn't look like it was built by your cousin's roommate in 1999. We create head-turning, professional websites for businesses that want to look like a million bucks without spending it.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://quickcheapwebsites.com"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true 
};

const publications = {
  title: "Publications",
  //subtitle: "EXPLORE A SELECTION OF PROJECTS THAT SHOWCASE MY EXPERTISE AND INNOVATION.",
  projects: [
    {
      image: require("./assets/images/AIforNewbies.png"),
      author: "By: Brady Lewis & Zach Crain",
      projectName: "AI for Newbies: A Beginner's Guide to Artificial Intelligence",
      projectSubline: "Amazon #1 Best Seller in Natural Language Processing, AI & Machine Learning, and more categories",
      projectDesc: "Step into the future effortlessly with \"AI for Newbies: How to Use Artificial Intelligence for the Average Human.\" This book is your friendly guide to understanding and embracing the wonders of AI, crafted especially for those who are new to the world of artificial intelligence.",
      footerLink: [
        {
          name: "View on Amazon",
          url: "https://www.amazon.com/AI-Newbies-Artificial-Intelligence-Beginners/dp/B0CX9D9PGD"
        }
        //  you can add extra buttons here.
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

const automations = {
  title: "Agents and Automations",
  subtitle: "CUSTOM-BUILT AI AGENTS AND AUTOMATIONS.",
  projects: [
    {
      image: require("./assets/images/automation1.jpg"),
      //author: "By: Brady Lewis & Zach Crain",
      projectName: "Daily Content Agent",
      //projectSubline: "Amazon #1 Best Seller in Natural Language Processing, AI & Machine Learning, and more categories",
      //projectDesc: "Step into the future effortlessly with \"AI for Newbies: How to Use Artificial Intelligence for the Average Human.\" This book is your friendly guide to understanding and embracing the wonders of AI, crafted especially for those who are new to the world of artificial intelligence.",
      footerLink: [
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/automation2.jpg"),
      //author: "By: Brady Lewis & Zach Crain",
      projectName: "RAG Marketing Agent",
      //projectSubline: "Amazon #1 Best Seller in Natural Language Processing, AI & Machine Learning, and more categories",
      //projectDesc: "Step into the future effortlessly with \"AI for Newbies: How to Use Artificial Intelligence for the Average Human.\" This book is your friendly guide to understanding and embracing the wonders of AI, crafted especially for those who are new to the world of artificial intelligence.",
      footerLink: [
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/automation3.jpg"),
      //author: "By: Brady Lewis & Zach Crain",
      projectName: "Ultimate Assistant Agent",
      //projectSubline: "Amazon #1 Best Seller in Natural Language Processing, AI & Machine Learning, and more categories",
      //projectDesc: "Step into the future effortlessly with \"AI for Newbies: How to Use Artificial Intelligence for the Average Human.\" This book is your friendly guide to understanding and embracing the wonders of AI, crafted especially for those who are new to the world of artificial intelligence.",
      footerLink: [
        //  you can add extra buttons here.
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Certifications"),
  subtitle:
    "Professional certifications kept up-to-date.",

  achievementsCards: [
    {
      title: "Salesforce Certified Administrator",
      subtitle:
        "2016-Present",
      image: require("./assets/images/salesforceLogo2.webp"),
      imageAlt: "Salesforce Administrator"
    },
    {
      title: "Salesforce Certified Marketing Cloud Developer",
      subtitle:
        "2019-Present",
      image: require("./assets/images/salesforceLogo2.webp"),
      imageAlt: "Salesforce Marketing Cloud Developer"
    },
    {
      title: "Salesforce Certified Marketing Cloud Consultant",
      subtitle: "2017-Present",
      image: require("./assets/images/salesforceLogo2.webp"),
      imageAlt: "Salesforce Marketing Cloud Consultant"
    },
    {
      title: "Salesforce Trailhead Double Ranger",
      subtitle:
        "2021-Present",
      image: require("./assets/images/salesforceLogo2.webp"),
      imageAlt: "Salesforce Administrator"
    },
    {
      title: "Salesforce Certified Email Marketing Specialist",
      subtitle:
        "2017-Present",
      image: require("./assets/images/salesforceLogo2.webp"),
      imageAlt: "Salesforce Marketing Cloud Developer"
    },
    {
      title: "Salesforce Certified Candidate Interviewer",
      subtitle: "2021-Present",
      image: require("./assets/images/salesforceLogo2.webp"),
      imageAlt: "Salesforce Marketing Cloud Consultant"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blog Posts",
  subtitle:
    "Read through some of my latest blog posts and articles on technology, AI, and more.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  /*blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],*/
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// YouTube section
export const youtubeSection = {
  display: true,
  title: "Videos, Guest Appearances & More",
  subtitle: "Check out a selection of some of my favorite on-screen appearances.",
  videos: [
    {"url":"https://www.youtube.com/watch?v=PjyJWQ79GNw", "title":"Unaligned: AI with Robert Scoble", "description":"Teaching AI to newbies with ⁠@gaimnetwork⁠'s founder (they make an app to bring AI to regular people). Lengthy discussion with founder Brady Lewis and host Robert Scoble. (Brady wrote a book on AI for newbies too). "},
    {"url":"https://www.youtube.com/watch?v=t1liepQuEks", "title":"AI Rebels Podcast ft. Brady Lewis", "description":"Join us on an enlightening journey with Brady Lewis, the visionary co-creator of GAIM.AI, as we dive into the world of artificial intelligence. Brady, who boasts a distinguished tenure as a senior manager at Salesforce, brings a wealth of knowledge and experience to the table."},
    {"url":"https://www.youtube.com/watch?v=d6N45uZbhzw", "title":"AI Rebels Podcast ft. Flow Orchestra", "description":"Want more time in your day? Brady Lewis and Zach Crain reveal their groundbreaking AI flow-building tool that's changing the game for productivity."},
    ]
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Ready to make some transformation magic together? Let's connect and explore how we can leverage AI to drive innovation and growth as a team!",
  //number: "+92-0000000000",
  email_address: "bradyllewis@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "bradylewistech", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  publications,
  automations,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
